import { AnalyticsBrowser } from '@segment/analytics-next';

let pageViewTime: Date;

const analytics = AnalyticsBrowser.load({
  writeKey: process.env.SEGMENT_ID || '',
});

const getTimeDiff = (startTime: Date, endTime: Date) => {
  const seconds = Math.round((endTime.getTime() - startTime.getTime()) / 1000);
  return seconds;
};

const convertMilliSecondToSecond = (duration: number) => {
  return Math.round(duration / 1000);
};

const getTotalActiveTime = (pageTime: any, idleTime: any) => {
  const totalDuration = getTimeDiff(pageTime, new Date());
  const totalIdleTime = convertMilliSecondToSecond(idleTime);
  return totalDuration - totalIdleTime;
};

export const sendPageViewEventToSegment = (title: string, search = '') => {
  const path = window.location.hash;
  const referrer = localStorage.getItem('PreviousUrl');
  const url = window.location.href;
  pageViewTime = new Date();

  analytics.page('page_viewed', {
    path,
    referrer,
    search,
    title,
    url,
  });
};

export const sendPageLeaveEventToSegment = async (
  title: string,
  path: string,
  url: string,
  referrer: string | null,
  search = '',
  totalIdleTime = 0,
  reVisitPage = false,
  prevIdleTime = 0
) => {
  pageViewTime = new Date();
  const idleTime = reVisitPage ? totalIdleTime - prevIdleTime : totalIdleTime;
  const result = await analytics.track('page_left', {
    name: 'page_left',
    path,
    referrer,
    search,
    title,
    url,
    start_time: pageViewTime.toLocaleString(),
    end_time: new Date().toLocaleString(),
    duration: getTotalActiveTime(pageViewTime, idleTime),
    idle_time: convertMilliSecondToSecond(idleTime),
  });
  return result;
};

export const sendEventToSegment = (event: string, data: any) => {
  analytics.track(event, data);
};
